import { IBrand } from "../../brands";
import { EntityTypes } from "../../EntityTypes";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ICurrentBrandResource } from "../types/ICurrentBrandResource";

export type ICurrentBrandUpdateMutationParameters = {
    brand?: RelationalValue<IBrand>;
};

export type ICurrentBrandUpdateMutationResult = ICurrentBrandResource;

export const currentBrandUpdateMutation: IApiMutationFunction<ICurrentBrandUpdateMutationParameters> = ({ brand }) => {
    return {
        method: "PUT",
        url: "/current_brand/self",
        // No brand means every brand: the api reads an explicit null, not a missing key.
        data: { brand: mapRelationalValueAsIRI(EntityTypes.BRAND, brand) ?? null },
    };
};

export const useCurrentBrandUpdateMutation = createApiMutationHook<
    ICurrentBrandUpdateMutationParameters,
    ICurrentBrandUpdateMutationResult
>(currentBrandUpdateMutation);
